import { render, staticRenderFns } from "./ActionHandleManuallyOrderedArticle.vue?vue&type=template&id=2c185ddf&scoped=true&"
import script from "./ActionHandleManuallyOrderedArticle.vue?vue&type=script&lang=js&"
export * from "./ActionHandleManuallyOrderedArticle.vue?vue&type=script&lang=js&"
import style0 from "./ActionHandleManuallyOrderedArticle.vue?vue&type=style&index=0&id=2c185ddf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c185ddf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
